// extracted by mini-css-extract-plugin
export default {"top":"MissionPage_top__3yvIi"};